export const delay = async (milliseconds: number) =>
	await new Promise(resolve => {
		setTimeout(resolve, milliseconds);
	});
